import * as api from '../api';
import toast from 'react-hot-toast';
import { DateFormatter2 } from '../../helpers/DateFormatter2';

export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
// export const GET_UNASSIGNED_CUSTOMER_SUCCESS =
//   "GET_UNASSIGNED_CUSTOMER_SUCCESS";
export const GET_INDIVIDUAL_CUSTOMER = 'GET_INDIVIDUAL_CUSTOMER';
export const GET_INDIVIDUAL_CUSTOMER_LAST5_TRANSACTION =
  'GET_INDIVIDUAL_CUSTOMER_LAST5_TRANSACTION';
export const GET_INDIVIDUAL_CUSTOMER_ALL = 'GET_INDIVIDUAL_CUSTOMER_ALL';
export const CLEAR_INDIVIDUAL_CUSTOMER = 'CLEAR_INDIVIDUAL_CUSTOMER';
export const CLEAR_INDIVIDUAL_CUSTOMER_TRANSACTIONS_ALL =
  'CLEAR_INDIVIDUAL_CUSTOMER_TRANSACTIONS_ALL';

export const createCustomer =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
        user: {
          userData: {
            sahakari: { name },
          },
        },
      } = getState();

      const data = {
        ...payload,
      };
      const response = await api.apiCreateCustomer(data, accessToken);
      handleSuccess();
    } catch (err) {
      handleFailure(err);
    }
  };

export const getCustomer = () => async (dispatch, getState) => {
  //currently table listing
  try {
    const {
      user: { accessToken },
    } = getState();
    // const response = await api.apiGetCustomer(accessToken);
    const response = await api.apiGetCustomerTableListing(accessToken);
    let dataArray = [];
    response.data.forEach((item) => {
      const tempArray = [
        item.customerId,
        item.accountName,
        // item.permanentTole,
        item.temporaryDistrict,
        item.mailMobileNumber,
        item.occupation,
        item.assignedCollectorId,
        item.assignedCollectorName,
        item.assignedCollectorMobileNumber,
        item.customerId,
      ];
      dataArray = [...dataArray, tempArray];
    });
    dispatch({ type: GET_CUSTOMER_SUCCESS, payload: dataArray });
  } catch (err) {
    toast.error('Error getting Customers. Please refresh');
  }
};

//unassignedCustomer
export const getUnassigendCustomers = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetUnassignedCustomer(accessToken);
    let dataArray = [];
    response.data.forEach((item) => {
      const tempArray = [
        item.customerId,
        item.accountName,
        item.permanentTole,
        item.mailMobileNumber,
        item.occupation,
        // item.assignedCollectorName,
        // item.assignedCollectorMobileNumber,
      ];
      dataArray = [...dataArray, tempArray];
    });
    dispatch({ type: GET_CUSTOMER_SUCCESS, payload: dataArray });
  } catch (err) {
    toast.error('Error getting Sahakari. Please refresh');
  }
};

export const getCustomerById =
  (id, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiGetCustomerById(accessToken, id);
      dispatch({ type: GET_INDIVIDUAL_CUSTOMER, payload: response.data });
      handleSuccess(response.data);
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const clearIndividualCustomer = () => {
  return { type: CLEAR_INDIVIDUAL_CUSTOMER };
};

export const updateCustomer =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiUpdateCustomer(accessToken, payload);
      handleSuccess();
      toast.success('Customer has successfully been Updated');
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const assignToCollector =
  (payload, handleSuccess = () => {}, handleFailure = () => {}) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiAssignCollector(accessToken, payload);
      toast.success('Customer has successfully been assigned to the collector');
      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const getLast5TransactionCustomer =
  (id) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiGetLast5TransactionCustomer(
        accessToken,
        id
      );
      dispatch({
        type: GET_INDIVIDUAL_CUSTOMER_LAST5_TRANSACTION,
        payload: response.data,
      });
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
    }
  };
export const getAllTransactionCustomerById =
  (id) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiGetAllTransactionCustomerById(
        accessToken,
        id
      );

      let dataArray = [];
      response.data.forEach((item) => {
        const formattedDate = item.createdDate;
        // const formattedDate = DateFormatter2(item.createdDate);
        const tempArray = [
          item.id,
          formattedDate,
          item.transactionType,
          item.amount,
          item.batchId,
          item.collectorId,
          item.collectorName,
          item.transactionStatus,
        ];
        dataArray = [...dataArray, tempArray];
      });

      dispatch({
        type: GET_INDIVIDUAL_CUSTOMER_ALL,
        payload: dataArray,
      });
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
    }
  };

export const clearAllTransactionsCustomer = () => {
  return { type: CLEAR_INDIVIDUAL_CUSTOMER_TRANSACTIONS_ALL };
};
